module.exports = __webpack_public_path__ + "img/light-switch-off-lg.546680d1.svg";